import { useTriggerLoad } from "@redotech/react-util/load";
import { DeliveryEstimate } from "@redotech/redo-model/estimate";
import DeliveryTruckIcon from "@redotech/redo-web/icon/delivery-truck.svg";
import PencilIcon from "@redotech/redo-web/icon/pencil.svg";
import { getStateCodeFromZipCode } from "@redotech/redo-web/state-code";
import { useState } from "react";
import {
  getProductEstimate,
  ShopifyExtensionClient,
} from "./client/shopify-extension-client";
import * as estimate from "./delivery-estimate.module.css";

const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function getFormattedDate(date: string | null): string {
  if (!date) {
    return "";
  }
  const dateTemp = Temporal.PlainDateTime.from(date);
  return `${daysOfWeek[dateTemp.dayOfWeek - 1]} ${month[dateTemp.month - 1]} ${dateTemp.day}`;
}

export const RedoEstimate = ({
  client,
  color,
  html,
  customCss,
  zipCode,
  country,
  city,
  region,
  minDate,
  maxDate,
}: {
  client: ShopifyExtensionClient;
  color: string;
  html?: string | null;
  customCss?: string;
  zipCode: string;
  country?: string;
  city?: string;
  region?: string;
  minDate: string;
  maxDate: string;
}) => {
  const [dates, setDates] = useState<DeliveryEstimate>({ minDate, maxDate });
  const [zip, setZip] = useState(zipCode);
  const [tempZip, setTempZip] = useState(zipCode);
  const [editZipOpen, setEditZipOpen] = useState(false);

  const [_load, trigger] = useTriggerLoad(async (signal) => {
    try {
      const stateCode = getStateCodeFromZipCode(zip);
      if (!stateCode) {
        return;
      }

      const estimate = await getProductEstimate(client, {
        signal,
        countryCode: "US",
        provinceCode: stateCode,
      });

      setDates({
        minDate: estimate.minDate,
        maxDate: estimate.maxDate,
      });
    } catch (error) {
      console.error(error instanceof Error ? error.stack : String(error));
    }
  });

  return (
    <div style={{ color }}>
      <div className={estimate.container} style={{ color }}>
        <style>{customCss}</style>
        <div className={estimate.deliveryIcon}>
          <DeliveryTruckIcon />
        </div>
        <span className={estimate.medSmText}>
          Estimated delivery <strong>{getFormattedDate(dates?.minDate)}</strong>{" "}
          to <strong>{getFormattedDate(dates?.maxDate)}</strong> to{" "}
          <button onClick={() => setEditZipOpen(!editZipOpen)}>
            <strong>{zip}</strong>{" "}
            <div className={estimate.editIcon}>
              <PencilIcon />
            </div>
          </button>
        </span>
      </div>
      {editZipOpen && (
        <div className={estimate.editZipContainer}>
          <div className={estimate.medSmText}>Input your zip code</div>
          <div className={estimate.editZipInput}>
            <input
              type="text"
              value={tempZip}
              onChange={(e) => setTempZip(e.target.value)}
            />
          </div>
          <div>
            <button
              onClick={() => {
                if (getStateCodeFromZipCode(tempZip)) {
                  setZip(tempZip);
                  trigger();
                  setEditZipOpen(false);
                } else {
                  setTempZip(zip);
                  setEditZipOpen(false);
                }
              }}
              className={estimate.saveButton}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
